import axios from 'axios';
import ElementUI from 'element-ui';
import { Loading } from 'element-ui'
import router from '../router/index'

let loading;
let loadingCount = 0;
function start() {
  loading = Loading.service({
    lock: false,
    spinner: 'el-icon-loading',
    text: '加载中.......',
    background: '#ffffffc9'
  })
};
function end() {
  loading.close();
}
function showLoaing() {
  if (loadingCount == 0) {
    start();
  };
  loadingCount++
};

function hideLoading() {
  loadingCount--;
  if (loadingCount == 0) {
    end()
  }
}

const service = axios.create({
  // process.env.NODE_ENV === 'development' 来判断是否开发环境
  // easy-mock服务挂了，暂时不使用了
  // baseURL: 'https://www.easy-mock.com/mock/592501a391470c0ac1fab128',
  timeout: 30000
});
// service.defaults.baseURL = 'http://ailuo.phpweb.68hanchen.com'//测试服务器
service.defaults.baseURL = 'https://points.solaxpower.com'//正式服务器
// service.defaults.baseURL = '/api'//本地
//添加请求拦截器
// const router = useRouter();
service.interceptors.request.use(
  config => {
    let token = localStorage.getItem('token');
    // console.log(token)
    if (token) {
      config.headers.Authorization = 'bearer ' + token;
    }
    showLoaing();
    return config;
  },
  error => {
    // console.log(error);
    return Promise.reject();
  }
);
//添加响应拦截器
service.interceptors.response.use(
  res => {
    if (res.status === 200) {
      if(res.data.status_code === 201 && res.data.result == false) {
        ElementUI.Message.error(res.data.message)
      } else if(res.data.status_code === 401){
        ElementUI.Message.error(res.data.message)
        hideLoading();
        return
      }
      hideLoading();
      return res.data;
    } else if (res.status === 401) {
      hideLoading();
      router.push("/login")
    } else {
      ElementUI.Message.error(res.msg)
      hideLoading();
      Promise.reject();
    }
  },
  error => {
    // console.log("error", error);
    if (error.response.data.message == 'Failed to authenticate because of bad credentials or an invalid authorization header.') {
      removeToken()
      hideLoading();
      router.push("/login")
      return Promise.reject();
    } else {
      ElementUI.Message.error(error.response.data.message)

      hideLoading();
      router.push("/login")
      return Promise.reject();
    }

  }
);

export default {
  //get请求
  get(url, param) {
    return new Promise((resolve) => {
      service({
        method: 'get',
        url,
        params: param,
      }).then(res => { //axios返回的是一个promise对象
        resolve(res) //resolve在promise执行器内部 
      }).catch(err => {
        // // console.log(err, '异常')
      })
    })
  },
  //导出文件流
  gets(url, param) {
    return new Promise((resolve) => {
      service({
        method: 'get',
        url,
        responseType: 'blob',
        params: param,
      }).then(res => { //axios返回的是一个promise对象
        resolve(res) //resolve在promise执行器内部 
      }).catch(err => {
        // // console.log(err, '异常')
      })

    })
  },
  //导出文件流
  posttwo(url, data) {
    return new Promise((resolve) => {
      service({
        method: 'post',
        url,
        responseType: 'blob',
        data: data,
      }).then(res => { //axios返回的是一个promise对象
        resolve(res) //resolve在promise执行器内部 
      }).catch(err => {
        // // console.log(err, '异常')
      })

    })
  },
  //post请求
  post(url, data) {
    return new Promise((resolve) => {
      service({
        method: 'post',
        url,
        data: data,
      }).then(res => {
        // hideLoading();
        resolve(res)
      }).catch(err => {
        // console.log(err, '异常')
      })
    })
  },
  //posts请求
  posts(url, data) {
    return new Promise((resolve) => {
      service({
        method: 'post',
        url,
        params: data,
      }).then(res => {
        // // console.log("res", res)
        resolve(res)
      }).catch(err => {
        // // console.log(err, '异常')
      })
    })
  },
}
